import Vue from "vue";
import Vuex from "vuex";

import * as WareInfo from "@/store/modules/WareInfo";

Vue.use(Vuex);

const store = new Vuex.Store<any>({
    modules:{
        WareInfo
    }
});

export default store;

if( sessionStorage != null ) {
    // 새로고침시 유지되어야할 데이터 로드
    const ware_info_json : string | null = sessionStorage.getItem("ware_info");
    if( ware_info_json != null && ware_info_json.length > 0 ) {
        store.commit("WareInfo/setWareInfo", JSON.parse(ware_info_json));
    }
}